/*
 * Este controlador es comportido por la vista de la lista de Notificaiones y por la Directiva de notificaiones
 * OJO: Si se inyecta algun componente en este controlados hay que hacerlo también en la directiva
 */
module.controller('notificationListCtrl', [ '$scope', '$rootScope', '$state', '$interpolate', 'notificationService', 'notificationResolveService', 'dateUtilService', 'ngToast', 'alertService', '$location',
		'$window', notificationListCtrlFn ]);
function notificationListCtrlFn($scope, $rootScope, $state, $interpolate, notificationService, notificationResolve, dateUtil, ngToast, alertService, $locationProvider, $windows) {

	var manualRefresh = false;
	$scope.loaded = false;
	$scope.notifications = [];
	$scope.totalNotifications = 0;
	$scope.totalNotificationsNotViewed = 0;
	$scope.pageSize = 25;
	$scope.newNotification = false;
	$scope.pagination = {
		total : 0,
		current : 1
	}
	var isDirective = $scope.hasOwnProperty('isDirective');

	/*
	 * Se cargan las 10 notificaiones más recientes y se solicitan la cantidad
	 * de las notificaiones no leidas
	 */
	$scope.search = function(page) {
		var filters = {
			limit : 10
		};
		if (!isDirective) {
			filters.limit = $scope.pageSize;
			page = page || 1;
			filters.offset = ($scope.pageSize * (page - 1));
		}

		// se solicita información al backend
		notificationService.search(filters).then(function(response) {
			var results = response.getData();
			$scope.notifications = results.results;
			$scope.totalNotifications = results.totalRegisters;
			$scope.pagination.total = results.totalRegisters;
			// se convierten todas las fechas a
			// moment
			$scope.notifications.forEach(function(n) {
				n.creationDate = dateUtil.formatMomentDateTime(n.creationDate);
				if (n.params.admitedDate)
					n.params.admitedDate = dateUtil.formatMomentDateTime(n.params.admitedDate);
				if (n.params.analyzedDate)
					n.params.analyzedDate = dateUtil.formatMomentDateTime(n.params.analyzedDate);
				if (n.params.sheduleDate)
					n.params.sheduleDate = dateUtil.formatMomentDateTime(n.params.sheduleDate);
			});

			loadMessageTypeInfo();

			$scope.loaded = true;
		}, function(response) {
		});
		getUnreadNotifications();
	}
	/*
	 * Se lee la información de el tipo de notificación y se carga la
	 * información correcta del mensaje a mostrar al usuario
	 */
	function loadMessageTypeInfo() {
		notificationResolve.getPromise().then(function() {
			$scope.notifications.forEach(function(n) {
				n.messageTypeInfo = notificationResolve.getById(n.messageType);
				n.messageTypeInfo.messageShort = $interpolate(n.messageTypeInfo.messageShort)(n.params);
				n.messageTypeInfo.messageLong = $interpolate(n.messageTypeInfo.messageLong)(n.params);
				if (n.messageTypeInfo.url)
					n.messageTypeInfo.url = $interpolate(n.messageTypeInfo.url)(n.params);
			});
		});
	}

	/*
	 * Se soliicta al servidor la cantidad de notiv=fivcaiones no vistas
	 */
	function getUnreadNotifications(viewToast) {
		if (angular.isUndefined(viewToast))
			viewToast = true;
		// se solicita las notificaciones no leidas
		notificationService.getUnreadNotifications().then(function(response) {
			var results = response.getData();
			$scope.totalNotificationsNotViewed = results.value;

			if ($scope.totalNotificationsNotViewed > 0 && viewToast) {
				makeToast("Tiene " + $scope.totalNotificationsNotViewed + " notificaciones sin leer")
				$scope.newNotification = true;
			}
		}, function(response) {
		});
	}
	/*
	 * Se revisa si hay notificaciones nuevas
	 */
	$scope.lookForNewNotifications = function() {
		// se obtiene el id de la notificacion más reciente
		var lastId = 0;
		if ($scope.notifications.length > 0)
			lastId = $scope.notifications[0].id;
		// se pregunta si hay nuevas notificaciones
		notificationService.areThereNewNotifications(lastId).then(function(response) {
			var results = response.getData();
			var update = results.value;
			if (!update) {
				if (manualRefresh)
					makeToast("No tiene nuevas notificaciones");
				manualRefresh = false;
				return;
			}
			makeToast("Tiene nuevas notificaciones");
			$scope.newNotification = true;
			$scope.search();
		}, function(response) {
		});
	}

	/*
	 * dar una notificacion por vista
	 */
	$scope.onNotificationClick = function(notification) {
		if (!notification.viewed) {
			notificationService.setNotificationViewed(notification.id).then(function(response) {
				notification.viewed = true;
				$scope.totalNotificationsNotViewed--;
				// genera la notificación desde la lista
				if (!isDirective)
					$rootScope.$broadcast('onChangeNotificationViewed', notification);
			}, function(response) {
			});
		}
	}

	/*
	 * solicitud manual de actualizacion de notificaciomes
	 */
	$scope.refreshNotifications = function() {
		console.log('refreshNotifications')
		manualRefresh = true;
		$scope.lookForNewNotifications();
	}

	/*
	 * recive el elento de cuando se cambia el estado de una notificacion en la
	 * lista
	 */
	$rootScope.$on('onChangeNotificationViewed', function(event, notification) {
		if (!isDirective) {
			return;
		}
		console.log('onChangeNotificationViewed');
		// se actualiza las notificaciones no leidas
		getUnreadNotifications(false);
		// si esta en notificaciones se cambia el estado
		var nt = findNotificationById(notification.id);
		if (nt)
			nt.viewed = true;
	})
	/*
	 * recive el elento de poner todas las notificaiones como vistas
	 */
	$rootScope.$on('onSetAllNotificationViewed', function() {
		if (!isDirective) {
			return;
		}
		console.log('onSetAllNotificationViewed');
		// se actualiza las notificaciones no leidas
		$scope.totalNotificationsNotViewed = 0;
		// si esta en notificaciones se cambia el estado
		$scope.notifications.forEach(function(n) {
			n.viewed = true;
		});
	})

	/*
	 * Marcar todas las notificaiones como leidas
	 */
	$scope.setAllAsViewed = function() {
		notificationService.setAllAsViewed().then(function(response) {
			$scope.notifications.forEach(function(n) {
				n.viewed = true;
			});
			$scope.totalNotificationsNotViewed = 0;

			alertService.showSuccess('Todas las notificaiones se marcan como vistas');

			// genera la notificación desde la lista
			if (!isDirective)
				$rootScope.$broadcast('onSetAllNotificationViewed');
		}, function(response) {
		});
	}

	$scope.notificationNotViewedShow = function() {
		if ($scope.totalNotificationsNotViewed < 100)
			return $scope.totalNotificationsNotViewed;
		return "99+";

	}

	function findNotificationById(id) {
		return $scope.notifications.find(function(n) {
			return n.id == id;
		});
	}

	function makeToast(text) {
		// si no es el llamdo de la directiva, no se generan toast
		if (!isDirective)
			return;

		var url = $windows.location.pathname + "#" + $state.get('home').url + $state.get('home.notificationList').url;
		ngToast.create({
			className : 'alert alert-info',
			content : "<a href='" + url + "' ui-sref='home.notificationList' class=''>" + text + '</a>'
		});
	}

	$scope.search();
}
